import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { addToBasket } from '@/js/lib/api/cart';
import { useCommonStore } from '@/js/lib/store/common';
import { useUserStore } from '@/js/lib/store/user';
import { useCartStore } from '@/js/lib/store/cart';
import { scrollToError } from '@/js/lib/helper/validate';
import { info } from '@/js/lib/ui';
import { mountModal } from '@/js/lib/ui/helper/dynamic-modal';
import IButton from '@/js/components/molecules/IButton.vue';
import ItemOptions from './ItemOptions.vue';
import AlreadyInCartModal from '@/js/components/www.iichi.com/organisms/modals/AlreadyInCartModal.vue';
import CartModal from '@/js/components/www.iichi.com/organisms/modals/CartModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'cart-button',
  props: {
    itemId: null,
    shopId: null,
    stock: null,
    hasOption: null,
    isOnVacation: null,
    buttonLabel: null
  },
  setup(__props: any) {

const props = __props as {
  itemId: number;
  shopId: number;
  stock: number;
  hasOption: 0 | 1;
  isOnVacation: 0 | 1;
  buttonLabel?: string;
};


const { isWebView } = useCommonStore();
const userStore = useUserStore();
const cartStore = useCartStore();
const observer = ref();
const cartButtonEl = document.querySelector('.cart-button');
const itemOptionVariantSlugs = ref<string[]>([]);
const available = computed(() => {
  if (props.shopId === userStore.memberId || props.isOnVacation || userStore.isBlackListed) {
    return false;
  }
  return props.stock > 0;
});
const selectOption = () => {
  document.querySelector('.cart-button').scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
};
const onSubmit = async () => {
  const isValid = await observer.value.validate();
  if (!isValid) {
    cartButtonEl.classList.remove('is-fixed');
    scrollToError();
    return;
  }
  if (available.value) {
    // 以前のeコマースオブジェクトをクリアする
    // eslint-disable-next-line unicorn/no-null
    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event: 'add_to_cart',
      ecommerce: {
        items: [
          {
            item_id: props.itemId,
            quantity: 1,
          },
        ],
      },
    });
    try {
      await addToBasket({ itemId: props.itemId, itemOptionVariantSlugs: itemOptionVariantSlugs.value });
      if (isWebView) {
        info('カートに追加されました', { fadeOut: true });
        return;
      }
      await cartStore.loadBaskets();
      mountModal({
        Component: CartModal,
      });
    } catch (error) {
      if (error?.response?.data?.errors.includes('already_in_cart')) {
        mountModal({
          Component: AlreadyInCartModal,
          props: {
            itemId: props.itemId,
            itemOptionVariantSlugs: itemOptionVariantSlugs.value,
          },
        });
        return;
      }
      if (error?.response?.data?.errors.includes('stock_missing')) {
        info('注文個数が在庫数を超えています');
        return;
      }
      info('カートに追加できませんでした');
    }
  }
};

return { __sfc: true,props, isWebView, userStore, cartStore, observer, cartButtonEl, itemOptionVariantSlugs, available, selectOption, onSubmit, IButton, ItemOptions }
}

})